function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#E83709",
  d: "M511.998 256c0 141.383-114.617 256-255.998 256C114.613 512 0 397.383 0 256S114.613 0 256 0c141.381 0 255.998 114.617 255.998 256z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#C20A00",
  d: "M510.24 226.379L314.482 97.09v79.633h-6v7.332h-63.998v255.293l90.158 60.293C437.537 466.445 511.998 369.938 511.998 256c0-10.023-.637-19.895-1.758-29.621z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#F1C40F",
  d: "M255.141 81.211c-125.441 0-117.414 144.949-98.914 178.965 15.039 27.66 34.668 36.969 34.668 73.168v1.512H314.85c0-.793-.008-1.32-.008-1.512-.555-30.336 12.695-36.965 34.672-73.168 20.093-33.098 30.039-178.965-94.373-178.965z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#F9A025",
  d: "M256.667 81.242v281.93h58.135c.023-16.68.063-28.719.039-29.828-.555-30.336 12.695-36.965 34.672-73.168 20.016-32.961 29.938-177.731-92.846-178.934z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#58301E"
}, React.createElement("path", {
  d: "M190.895 333.344c0 1.586.023 25.469.074 53.32h123.74c.055-27.852.133-51.734.133-53.32H190.895z"
}), React.createElement("path", {
  d: "M230.338 424.965l45.027-.11 39.344-38.191-77.541-5.262-46.199 5.262z"
}));

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#3B2314",
  d: "M256.667 333.344v53.32h58.042c.055-27.852.133-51.734.133-53.32h-58.175z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFF",
  d: "M230.338 424.965c4.465 9.176 10.98 15.773 22.451 15.773 11.467 0 18.092-7.297 22.576-15.883l-45.027.11z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  fill: "#3B2314",
  d: "M275.365 424.855l39.344-38.191-58.042-3.941v42.168z"
}));

var SvgLightBulb2 = function SvgLightBulb2(props) {
  return React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 511.998 512"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

export default __webpack_public_path__ + "static/light-bulb2.67a30184.svg";
export { SvgLightBulb2 as ReactComponent };